const ASSESSMENT_DATA = [
  {
    id: 1,
    assessmentTitle: "BLOCKCHAIN",
    routeName: "ABC",
    subjects: [
      {
        id: 1,
        name: "Brown Brim",
        marks: 50,
      },
      {
        id: 2,
        name: "Blue Beanie",
        marks: 50,
      },
      {
        id: 3,
        name: "Brown Cowboy",
        marks: 50,
      },
      {
        id: 4,
        name: "Grey Brim",
        marks: 50,
      },
      {
        id: 5,
        name: "Green Beanie",
        marks: 50,
      },
      {
        id: 6,
        name: "Palm Tree Cap",
        marks: 50,
      },
      {
        id: 7,
        name: "Red Beanie",
        marks: 50,
      },
      {
        id: 8,
        name: "Wolf Cap",
        marks: 50,
      },
      {
        id: 9,
        name: "Blue Snapback",
        marks: 50,
      },
    ],
  },
  {
    id: 2,
    assessmentTitle: "MACHINE-LEARNING",
    routeName: "MNQ",
    subjects: [
      {
        id: 10,
        name: "Adidas NMD",
        marks: 500,
      },
      {
        id: 11,
        name: "Adidas Yeezy",
        marks: 500,
      },
      {
        id: 12,
        name: "Black Converse",
        marks: 500,
      },
      {
        id: 13,
        name: "Nike White AirForce",
        marks: 500,
      },
      {
        id: 14,
        name: "Nike Red High Tops",
        marks: 500,
      },
      {
        id: 15,
        name: "Nike Brown High Tops",
        marks: 500,
      },
      {
        id: 16,
        name: "Air Jordan Limited",
        marks: 500,
      },
      {
        id: 17,
        name: "Timberlands",
        marks: 500,
      },
    ],
  },
];

export default ASSESSMENT_DATA;
